module.exports = __webpack_public_path__ + "77872145052ba524e90485995e05b9ce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-10.png
// module id = 3305
// module chunks = 0